import { Box, Typography } from "@mui/material";
import { PIPELINE_COLUMNS } from "../Pipeline/pipelineColumns";
import { PipelineStage } from "../Pipeline/types";

type Props = {
  currentStage: PipelineStage;
};

export default function PipelineStageProgressBar({ currentStage }: Props) {
  const activeIndex = PIPELINE_COLUMNS.findIndex((column) => column.stage === currentStage);

  return (
    <Box sx={{ display: "flex", width: "100%", borderRadius: "8px", overflow: "hidden", border: "1px solid #E0E0E0" }}>
      {PIPELINE_COLUMNS.map((column, index) => {
        const isActive = index === activeIndex;
        const isPast = index < activeIndex;

        return (
          <Box
            key={column.stage}
            sx={{
              flex: 1,
              py: 1.25,
              px: 1,
              textAlign: "center",
              backgroundColor: isActive ? column.borderColor : isPast ? "#F5F5F5" : "background.paper",
              borderRight: index < PIPELINE_COLUMNS.length - 1 ? "1px solid #E0E0E0" : "none",
            }}
          >
            <Typography
              sx={{
                fontSize: 11,
                fontWeight: 700,
                letterSpacing: 0.5,
                textTransform: "uppercase",
                color: isActive ? "#fff" : isPast ? "text.secondary" : "text.disabled",
                lineHeight: 1.2,
              }}
            >
              {column.title}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}
